var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseSlipSelection } from "../BaseSlipSelection";
var QASlipSelection = /** @class */ (function (_super) {
    __extends(QASlipSelection, _super);
    function QASlipSelection(source) {
        var _this = _super.call(this, source) || this;
        _this.eventDate = source.eventDate;
        _this.lineTypeId = source.lineTypeId;
        _this.betTypeId = source.betTypeId;
        _this.useEventName = source.useEventName;
        _this.eventName = source.eventName;
        _this.lineName = source.lineName;
        _this.asianLineName = source.asianLineName;
        _this.mappedLineTypeId = source.mappedLineTypeId;
        _this.swapped = source.swapped;
        _this.splitTypeId = source.splitTypeId;
        _this.SISEventId = source.SISEventId;
        _this.GBSEventId = source.GBSEventId;
        _this.feedEventId = source.feedEventId;
        _this.feedProviderId = source.feedProviderId;
        _this.isEachWayEnabled = source.isEachWayEnabled;
        _this.placeTermsId = source.placeTermsId;
        _this.relatedToId = source.relatedToId;
        _this.eachWayMaxStake = source.eachWayMaxStake;
        _this.eachWayMaxStakeCombo = source.eachWayMaxStakeCombo;
        _this.eachWayComboBetIsEnabled = source.eachWayComboBetIsEnabled;
        _this.eachWayMinBet = source.eachWayMinBet;
        _this.qaParameter1 = source.qaParameter1;
        _this.qaParameter2 = source.qaParameter2;
        return _this;
    }
    return QASlipSelection;
}(BaseSlipSelection));
export { QASlipSelection };
//# sourceMappingURL=QASlipSelection.js.map